import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Selection,
  Inject,
  Edit,
  Toolbar,
  Sort,
  Filter,
  Resize,
} from "@syncfusion/ej2-react-grids";
// import hello from "../../data/default_prod2.png";
import {
  checkBOMbyId,
  DeleteBOMById,
  getBOMsbyProduct,
  getBOMsProductList,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";

const BOMs = () => {
  const { currentColor, userPermID, userObj } = useStateContext();
  const [getbrands, setbrands] = useState([]);
  const [brand, setbrand] = useState("");
  const [AllProducts, setAllProducts] = useState("");

  const [p_id, setCode] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(true);

  const navigate = useNavigate();

  const ProductGridactiveStatus = (props) => (
    <div className="flex gap-2 justify-center items-center text-gray-700 capitalize">
      {props.is_active === false ? (
        <button
          type="button"
          style={{ background: "red" }}
          className="text-white py-2 px-2 capitalize rounded-2xl text-md"
        >
          <label>Non-Active</label>
        </button>
      ) : (
        <button
          type="button"
          style={{ background: "blue" }}
          className="text-white py-2 px-2 capitalize rounded-2xl text-md"
        >
          <label>Active</label>
        </button>
      )}
    </div>
  );

  const customersGrid = [
    {
      field: "bom_id",
      headerText: "Id",
      minWidth: "100",
      width: "120",
      maxWidth: "170",
      textAlign: "center",
    },
    {
      field: "pname",
      headerText: "Product Name",
      minWidth: "180",
      width: "480",
      maxWidth: "640",
      textAlign: "left",
    },
    {
      field: "code",
      headerText: "Code",
      minWidth: "155",
      width: "155",
      maxWidth: "170",
      textAlign: "left",
    },
    {
      field: "revision",
      headerText: "Revision",
      minWidth: "160",
      width: "170",
      maxWidth: "180",
      textAlign: "left",
    },
    {
      field: "effdate",
      headerText: "Eff from",
      minWidth: "140",
      width: "150",
      maxWidth: "160",
      textAlign: "center",
    },
    {
      field: "is_active",
      headerText: "Active Status",
      template: ProductGridactiveStatus,
      minWidth: "170",
      width: "180",
      maxWidth: "190",
      textAlign: "center",
    },
  ];

  const handleAddNewProdClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      // console.log("Add new");
      navigate("/BOMs/AddEditBOM");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEditProductClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      if (p_id !== "") {
        navigate(`/BOMs/AddEditBOM/${p_id}`);
      } else {
        alert("Please select BOM to edit!");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDeleteProductClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      if (p_id !== "" && userObj) {
        const { user_id, user_token } = userObj;
        const resp1 = await checkBOMbyId(p_id, user_id, user_token);
        if (resp1.data[0].ordersCount > 0) {
          alert("This BOM is used in Work Orders!\n\nIt cannot be deleted.");
          return;
        } else {
          if (window.confirm(`Are you sure you want to delete BOM: ${p_id}?`)) {
            DeleteBOMById(p_id, user_id, user_token)
              .then((resp) => {
                if (resp.status === 200) {
                  window.location.reload();
                  alert(`BOM: ${p_id} deleted successfully.`);
                } else {
                  alert(`BOM: ${p_id} fail to delete.`);
                }
              })
              .catch((err) => {
                console.error(err.message);
              });
          }
        }
        navigate(`/BOMs`);
      } else {
        alert("Please select BOM to delete.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleViewProductClick = async (event) => {
    TimeoutUtility.resetTimeout();
    try {
      if (p_id !== "") {
        navigate(`/BOMs/ViewBOM/${p_id}`);
      } else {
        alert("Please select BOM to view!");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleRowSelected = (args) => {
    setCode(args.data.bom_id);
  };

  const handleChangeBrand = (e) => {
    TimeoutUtility.resetTimeout();
    if (e.target.value === 0) {
      setbrand(null);
    } else {
      setbrand(e.target.value);
    }
  };

  function updateData(brd) {
    if (userObj) {
      const { user_id, user_token } = userObj;
      setloading(true);
      trackPromise(
        Promise.all([getBOMsbyProduct(brd, user_id, user_token)])
          .then(([productsResponse]) => {
            setAllProducts(productsResponse.data);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          })
          .finally(() => {
            setloading(false);
          })
      );
    }
  }

  useEffect(() => {
    async function fetchData() {
      try {
        var b;
        if (brand === null || brand === "" || brand === "0") {
          b = null;
        } else {
          b = brand;
        }
        updateData(b);
      } catch (ex) {}
    }
    fetchData();
  }, [brand]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    const fetchData = async () => {
      try {
        if (userObj) {
          const { user_id, user_token } = userObj;
          setloading(true);

          trackPromise(
            Promise.all([getBOMsbyProduct(null, user_id, user_token)])
              .then(([productsResponse]) => {
                // console.log(productsResponse.data);
                setAllProducts(productsResponse.data);
              })
              .catch((error) => {
                console.error("Error fetching data:", error);
              })
              .finally(() => {
                setloading(false);
              })
          );

          await getBOMsProductList(user_id, user_token)
            .then((resp) => {
              setbrands(resp.data || []);
            })
            .catch((err) => {
              console.log(err.message);
            });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [userObj]);

  return (
    <div>
      <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
        <Header category="Stock" title="BOMS" />
        <Container fluid className="g-0 p-0 justify-end">
          <Row xs={2} className="button-row justify-content-end font-normal">
            {userPermID.includes(5009) && (
              <>
                <Col md="auto" style={{ padding: "0" }}>
                  <Button
                    margin="6px"
                    color="white"
                    bgColor={currentColor}
                    text="Create New"
                    borderRadius="10px"
                    onClick={handleAddNewProdClick}
                  />
                </Col>
                <Col md="auto" style={{ padding: "0" }}>
                  <Button
                    margin="6px"
                    color="white"
                    bgColor={currentColor}
                    text="Update"
                    borderRadius="10px"
                    onClick={handleEditProductClick}
                  />
                </Col>
                <Col md="auto" style={{ padding: "0" }}>
                  <Button
                    margin="6px"
                    color="white"
                    bgColor={currentColor}
                    text="Delete"
                    borderRadius="10px"
                    onClick={handleDeleteProductClick}
                  />
                </Col>
              </>
            )}
            <Col md="auto" style={{ padding: "0" }}>
              <select
                className="select-custom rounded-xl"
                value={brand}
                onChange={handleChangeBrand}
              >
                <option value={0}>{"All Products"}</option>
                {getbrands.map((item, index) => (
                  <option key={index} value={item.product_id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </Col>
          </Row>
        </Container>
        {loading && promiseInProgress ? (
          <LoadingIndicator />
        ) : (
          <>
            <GridComponent
              className="custom-grid"
              dataSource={AllProducts}
              allowPaging={true}
              recordDoubleClick={
                userPermID.includes(5007) && handleViewProductClick
              }
              pageSettings={{
                pageSize: 10,
                pageSizes: [10, 16, 48, 100, "All"],
              }}
              enablePersistence={true}
              height="calc(62vh - 60px)"
              allowSorting
              allowResizing
              toolbar={[{ text: "Search" }]}
              rowSelected={handleRowSelected}
              rowHeight={36}
            >
              <ColumnsDirective>
                {customersGrid.map((item, index) => (
                  <ColumnDirective key={index} {...item} />
                ))}
              </ColumnsDirective>

              <Inject
                services={[
                  Resize,
                  Page,
                  Toolbar,
                  Selection,
                  Edit,
                  Sort,
                  Filter,
                ]}
              />
            </GridComponent>
          </>
        )}
      </div>
    </div>
  );
};

export default BOMs;
